module.exports = __webpack_public_path__ + "img/home_story_card1.e42015ce.svg";